
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"4","cy":"4","r":"1"}}),_c('circle',{attrs:{"cx":"4","cy":"12","r":"1"}}),_c('circle',{attrs:{"cx":"4","cy":"20","r":"1"}}),_c('path',{attrs:{"d":"M20 5H7.88a1 1 0 010-2H20a1 1 0 010 2zm0 8H7.88a1 1 0 010-2H20a1 1 0 010 2zm0 8H7.88a1 1 0 010-2H20a1 1 0 010 2z"}})])
          )
        }
      }
    